export const STORE_PROJECT_VISUAL_BLOCKS = 'projectVisualBlocksUI';
export type STORE_PROJECT_VISUAL_BLOCKS = typeof STORE_PROJECT_VISUAL_BLOCKS;

export const STORE_VISUAL_BLOCKS_CHATBOT = 'visualBlocksChatbotUI';
export type STORE_VISUAL_BLOCKS_CHATBOT = typeof STORE_VISUAL_BLOCKS_CHATBOT;
